import React from "react";
import { formatCommenceTime, getTimezoneAbbrev } from "./dateFormat";
import { isEmpty } from "./isEmpty";

/** Game commence time + dynamic CST/CDT label (America/Chicago). */
export default function GameDateDisplay({
  dateTime,
  wrapperClassName = "leftPart dateText",
  timeClassName = "fs14",
  tzClassName = "fs12",
  tzAs = "button",
}) {
  if (isEmpty(dateTime)) return null;

  const tzLabel = getTimezoneAbbrev(dateTime);
  const TzTag = tzAs === "span" ? "span" : "button";

  return (
    <div className={wrapperClassName}>
      <p className={timeClassName}>{formatCommenceTime(dateTime)}</p>
      <TzTag
        className={tzClassName}
        type={tzAs === "button" ? "button" : undefined}
        style={{
          pointerEvents: "none",
          cursor: tzAs === "span" ? "default" : undefined,
        }}
      >
        {tzLabel}
      </TzTag>
    </div>
  );
}
